import {
  effect,
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import {
  CommandStore,
  NotificationStore,
  SOFTLINE_CONFIG_ONE_SIGNAL_APP_ID,
  SOFTLINE_FEATURE_COMMANDS,
  SOFTLINE_FEATURE_NOTIFICATION,
} from '@softline/application';
import {
  UserInfoService,
} from '@softline/auth';
import { Store } from '@softline/core';
import { map } from 'rxjs';

export const notificationProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    const oneSignalAppId = inject(SOFTLINE_CONFIG_ONE_SIGNAL_APP_ID, { optional: true });
    if (!oneSignalAppId) return;

    const userInfo = inject(UserInfoService);

    store.commit(SOFTLINE_FEATURE_COMMANDS, CommandStore.mutations.addSet, {
      name: 'notifications',
      priority: 1,
      commands: [
        {
          name: '#UTILITIES.NOTIFICATIONS.TITLE',
          routerLink: ['notifications'],
          icon: 'fa-regular fa-bell',
          class: 'menu main-menu main-menu-bottom',
          badge: store
            .observe(SOFTLINE_FEATURE_NOTIFICATION, NotificationStore.getters.all)
            .pipe(
              map((o) => {
                const length = o.filter((p) => !p.readtime).length;
                return length > 0 ? `${length}` : '';
              })
            ),
        },
      ],
    });

    let previousUserId: number | null | undefined;
    effect(async () => {
      const currentUserId = userInfo.value()?.userId;
      if (!currentUserId) {
        previousUserId = null;
        return;
      }
      if (previousUserId === currentUserId) return;
      previousUserId = currentUserId;
      try {
        await store.dispatch(
          SOFTLINE_FEATURE_NOTIFICATION,
          NotificationStore.actions.loadMany,
          {}
        );
      } catch (e) {
        console.warn('[notificationProviders.ENVIRONMENT_INITIALIZER]', e);
      }
    });
  }),
];
